<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Henviser</mat-label>
      <input
        type="text"
        placeholder="Vælg henviser"
        aria-label="Henviser"
        matInput
        #henviserInput
        [formControl]="henviserCtrl"
        [matAutocomplete]="auto"
        (blur)="onBlur()"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="henviserSelected($event)">
          @for (henviser of filteredHenvisere | async; track henviser) {
            <mat-option [value]="henviser">
              {{ henviser.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
